import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import styles from './ProxyCheckerSingleResult.module.scss'

import {
  Server as ServerIcon,
  Timer as TimerIcon,
  MapLocation as LocationIcon,
} from '../../../../icons'

import {
  selectProxyCheckerResult,
  selectProxyCheckerActivationStatus,
  selectLocations,
} from 'store/service/selectors'

const ProxyCheckerSingleResult: React.FC = () => {
  const checkerResult = useSelector(selectProxyCheckerResult)
  const wasProxyCheckerActivated = useSelector(
    selectProxyCheckerActivationStatus
  )
  const locations = useSelector(selectLocations)

  if (!wasProxyCheckerActivated) {
    return null
  }

  console.log('checkerResult', checkerResult)

  const result = checkerResult?.results[0]

  if (!result) {
    return null
  }

  const location = !!result.ipInfo?.country
    ? `${result.ipInfo?.country}, region: ${result.ipInfo?.region}, city: ${result.ipInfo?.city}, ISP: ${result.ipInfo?.org}`
    : null

  const countryName = !!locations
    ? locations[result.ipInfo?.country?.toLowerCase()]?.name
    : 'n/a'

  return (
    <div className={styles.container}>
      <div className={styles.title}>Proxy checker result</div>

      <div className={styles.itemsRow}>
        <div className={styles.item}>
          <div className={styles.itemIconWrapper}>
            <ServerIcon />
          </div>

          <div>
            <div className={styles.itemValue}>
              {result.resolvedIp}
            </div>
            <div className={styles.itemLabel}>
              IP address
            </div>
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.itemIconWrapper}>
            <TimerIcon />
          </div>

          <div>
            <div className={styles.itemValue}>
              {result.requestMetrics.totalTime
                ? result.requestMetrics.totalTime.toFixed(2) + ' ms'
                : ''}
            </div>
            <div className={styles.itemLabel}>
              Latency
            </div>
          </div>
        </div>
      </div>

      <div className={styles.item}>
        <div className={styles.itemIconWrapper}>
          <LocationIcon />
        </div>

        <div>
          <div className={styles.itemValue}>
            {countryName}
          </div>
          <div className={styles.itemLabel}>
            {location}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProxyCheckerSingleResult
